import { MailOutlined, PhoneOutlined, PushpinOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Card } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { WL_CONFIG } from 'constants';
import { priceTransformer } from 'utils';

function SnapshotPanel({ customer, addressDisplay, onCompanyClick }) {
  const daysSinceLastOrder = customer?.last_order_date
    ? dayjs().diff(dayjs(customer.last_order_date), 'day')
    : null;

  return (
    <Card title="Profile Snapshot" className="snapshot-card">
      <div className="snapshot-header">
        <Avatar
          size={48}
          icon={<UserOutlined />}
          style={{ backgroundColor: WL_CONFIG.colors.primary }}
        >
          {customer?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <div className="snapshot-info">
          <div className="snapshot-name">{customer?.name || 'No name'}</div>
          <div className="snapshot-meta">
            {customer?.company_detail ? (
              <a href="#" onClick={(e) => { e.preventDefault(); onCompanyClick?.(); }}>
                {customer.company_detail.name}
              </a>
            ) : (
              <span className="muted">No company</span>
            )}
          </div>
        </div>
      </div>
      <div className="snapshot-details">
        <div className="snapshot-row">
          <MailOutlined className="snapshot-icon" />
          <span>{customer?.email || '-'}</span>
        </div>
        <div className="snapshot-row">
          <PhoneOutlined className="snapshot-icon" />
          <span>{customer?.phone || '-'}</span>
        </div>
        <div className="snapshot-row">
          <PushpinOutlined className="snapshot-icon" />
          <span className="truncate">{addressDisplay || '-'}</span>
        </div>
      </div>
      <div className="snapshot-stats">
        <div className="stat">
          <span className="stat-label">Total Spend</span>
          <span className="stat-value">{priceTransformer(customer?.total_spent ?? 0)}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Orders</span>
          <span className="stat-value">{customer?.orders_count ?? 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Days Since Last</span>
          <span className="stat-value">{daysSinceLastOrder != null ? `${daysSinceLastOrder}d` : '-'}</span>
        </div>
      </div>
      <div className="snapshot-footer">
        Customer since {customer?.created_at ? dayjs(customer.created_at).format('MMM D, YYYY') : '-'}
      </div>
    </Card>
  );
}

export default SnapshotPanel;
